var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppTwoColumnsSelector',{attrs:{"items":_vm.carTypesAll,"value":_vm.menuSetting.orderDescription.targetCarType.carTypes,"is-show-all-select":true,"available-label":"車種一覧","chosen-label":"設定対象車種"},on:{"changeChosenItems":function($event){_vm.menuSetting.orderDescription.targetCarType.carTypes = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }